import { states } from '@/constants/lifecycle';
import Fetch, { fetchConfig } from '@/hooks/fetch';
import { hasMinimumLength } from '@/utils/resultsHelper';
import actions, { pollingStatus } from '../constants';

export default {
  useFetchRequest: ({ category, code }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST,
    readStatus,
    { category, code },
  ),
  useFetchWorkflowForRequest: ({ category, code, requestCode }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_WORKFLOW_FOR_REQUEST,
    readStatus,
    { category, code, requestCode },
  ),
  usePollRequest: ({
    category, code, polling, saveStatus,
  }) => Fetch.useFetchDispatch(
    actions.POLL_REQUEST,
    states.NONE,
    { category, code },
    fetchConfig(
      [category, code, polling, saveStatus],
      () => polling === pollingStatus.NONE && saveStatus !== states.ERROR && hasMinimumLength(code),
    ),
  ),
  useNewRequestFromSource: ({
    category, code, requestSourceType, requestSourceCode,
  }, readStatus) => Fetch.useFetchDispatch(
    actions.NEW_REQUEST_FROM_SOURCE,
    readStatus,
    {
      category, code, requestSourceType, requestSourceCode,
    },
  ),
};
